        var bsSlideshow = {
            init: function (element, span) {              
                var self = this;       
                self.current = 1;
                self.count = $(element).children("div").length;
                self.element = element;
                self.span = span == null ? 8 : span;
              
              /*
               var _buttonContainer = $('<span>').addClass('slide-button-container').appendTo($(element));
                $("<span><\/span>", {
                    "class": "next",
                    click: function () {
                        self.click(this)
                    }
                }).appendTo($(_buttonContainer));
                $("<span><\/span>", {
                    "class": "previous",
                    click: function () {
                        self.click(this)
                    }
                }).appendTo($(_buttonContainer));
                $(window).focus(function () {
                    self.resume();
                });
                $(window).blur(function () {
                    self.pause(false);
                });
              */
              
              $('.slide-button-container .next').on('click', function(){
               		self.click(this)
              });
              $('.slide-button-container .previous').on('click', function(){
               		self.click(this)
              });
              
              
                self.start();
            },           
            start: function () {
                var self = this;
                this.interval = setInterval(function () {
                    if (self.totalSeconds >= self.span) {
                        self.next();
                        self.totalSeconds = 0;
                    }
                    self.totalSeconds += 1;   
                }, 1000);
            },
            pause: function (reset) {     
                var self = this;
                var r = $.Deferred();               
                if (reset) {
                    self.totalSeconds = 0;
                }
                return clearInterval(self.interval), delete self.interval, r.resolve().promise();
            },
            resume: function () {
                var self = this;
                var r = $.Deferred();
                return (!self.interval) ? self.start() : console.log('Interval not cleared'), r.resolve().promise();
            },
            click: function (n) {
                var self = this;
                self.intranstion ? (console.log("intranstion value is true"), self.pause(true).done(function () {
                    self.resume()
                })) : (self.pause(true), $(n).hasClass("next") ? self.next().done(function () {
                    self.resume()
                }) : self.previous().done(function () {
                    self.resume()
                }))
            },
            next: function () {                
                var self = this;          
                var n = $.Deferred(), 
                 t = self.current;
                return self.current = self.current == self.count ? 1 : self.current + 1, self.switch("previn", "prevout", t).done(function () {
                    n.resolve();
                }), n.promise();
            },
            previous: function () {  
                var self = this;
                var n = $.Deferred(),
                    t = self.current;
                return self.current = self.current == 1 ? self.count : self.current - 1, self.switch("nextin", "nextout", t).done(function () {
                    n.resolve()
                }), n.promise()
            },
            switch: function (n, t, i) {          
                var self = this;
                var r = $.Deferred(),
                    u = $.Deferred();
                self.intranstion = !0;
                $(self.element).children("div:nth-child(" + self.current + ")").addClass(n).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function () {

                    $(self.element).children("div:nth-child(" + self.current + ")").removeClass(n).addClass("active");
                    r.resolve()
                });
                $(self.element).children("div:nth-child(" + i + ")").addClass(t).on("animationend webkitAnimationEnd oAnimationEnd MSAnimationEnd", function () {
                    $(self.element).children("div:nth-child(" + i + ")").removeClass(t).removeClass("active");
                    u.resolve()
                });
                return $.when(r, u).done(function () {
                    self.intranstion = !1
                }).promise()
            },
            totalSeconds: 0,
            element: null,
            count: null,
            span: null,
            current: null,
            intranstion: null
        }